import type { ReportType } from "../api/types";

/**
 * Every query key. Keys nest, so invalidating one invalidates the keys under it: `keys.iz` covers
 * the searches and every search's record and screenings, `keys.search(uid)` one search's record
 * and screenings, and `keys.shl` the links and their logs.
 */
export const keys = {
  me: ["me"] as const,
  devices: ["me", "devices"] as const,
  providerConfigs: ["providerConfigs"] as const,
  iz: ["iz"] as const,
  searches: ["iz", "searches"] as const,
  search: (searchUid: string) => ["iz", "search", searchUid] as const,
  record: (searchUid: string) => ["iz", "search", searchUid, "record"] as const,
  screenings: (searchUid: string) => ["iz", "search", searchUid, "screenings"] as const,
  shl: ["shl"] as const,
  shlLogs: (linkId: string) => ["shl", linkId, "logs"] as const,
  vci: (recordUid: string) => ["vci", recordUid] as const,
  report: (searchUid: string, reportType: ReportType) => ["report", searchUid, reportType] as const,
};
